// Creator-choice stepper bound: choice is an integer in [0, poolSize]. 0 means "all" (fixed, receive every SKU).
export function clampChoiceCount(choice: number, poolSize: number): number {
  return Math.max(0, Math.min(poolSize, Math.floor(choice)));
}
